"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BANK_CODES = void 0;
exports.BANK_CODES = {
    itau: '341',
    inter: '077',
    inter_2: '77',
    btg: '208',
};
